(function(){
  var DUR=340,EASE='cubic-bezier(.4,0,.2,1)';
  function ex(d,p){d.dataset.busy='1';d.open=true;var t=p.scrollHeight;p.animate([{height:'0px',opacity:0},{height:t+'px',opacity:1}],{duration:DUR,easing:EASE}).onfinish=function(){delete d.dataset.busy;};}
  function cl(d,p){d.dataset.busy='1';var s=p.offsetHeight;p.animate([{height:s+'px',opacity:1},{height:'0px',opacity:0}],{duration:DUR,easing:EASE}).onfinish=function(){d.open=false;delete d.dataset.busy;};}
  function init(root){
    if(!root||root.dataset.kgInit)return;
    root.dataset.kgInit='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ok=!!(window.Element&&Element.prototype.animate)&&!reduce;
    var solo=root.getAttribute('data-solo')==='1';
    var items=root.querySelectorAll('details.kg-faq__item');
    for(var i=0;i<items.length;i++){(function(d){
      var p=d.querySelector('.kg-faq__a'),s=d.querySelector('summary');
      if(!p||!s)return;
      s.addEventListener('click',function(e){
        if(!ok)return;
        e.preventDefault();
        if(d.dataset.busy)return;
        if(d.open){cl(d,p);return;}
        if(solo){var op=root.querySelectorAll('details.kg-faq__item[open]');for(var j=0;j<op.length;j++){if(op[j]!==d)cl(op[j],op[j].querySelector('.kg-faq__a'));}}
        ex(d,p);
      });
    })(items[i]);}
  }
  function boot(){var r=document.querySelectorAll('.kg-faq');for(var i=0;i<r.length;i++)init(r[i]);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
